export const FREQUENCY_IMMEDIATE = 'immediate';
export const FREQUENCY_WEEKLY = 'weekly';
export const FREQUENCY_MONTHLY = 'monthly';
export const FREQUENCY_DISABLED = 'disabled';

export default class UserProductGroupNotificationSettings {
	frequency: string;

	constructor(frequency: string) {
		this.frequency = frequency;
	}

	isDisabled(): boolean {
		return this.frequency === 'disabled';
	}
}
